import { Nullable } from "@/api/ApiClient";

export type ExpenseNoteFormData = Nullable<{
    id: string | undefined,
    sequence: string,
    document_key: string,
    numero: string,
    fecha: string,
    tipo: string,
    subtotal: number,
    descuento: number,
    impuestos: number,
    total: number,
    exchange_rate: number,
    expenseId: string,
    expense: any,
    currencyId: string,
    currency: any,
}>;

export const ExpenseNoteRelatedAttributes: Array<keyof ExpenseNoteFormData> = ["expense", "currency"];